"use strict";

function openSummerGamesModal() {
  console.log('open modal');
  var modal = document.getElementById('js-modal-summer-games');
  document.documentElement.style.overflow = 'hidden';
  modal.classList.add('is-open');
}

function closeSummerGamesModal() {
  var modal = document.getElementById('js-modal-summer-games');
  document.documentElement.style.overflow = 'auto';
  modal.classList.remove('is-open');
}

window.addEventListener("DOMContentLoaded", function () {
  var form = document.querySelector('.js-summer-games-form');
  var inputs = form.querySelectorAll('input');
  var first_name = form.querySelectorAll('input[name="first_name"]')[0];
  var last_name = form.querySelectorAll('input[name="last_name"]')[0];
  var email = form.querySelectorAll('input[name="email"]')[0];
  var submit = form.querySelector('.js-submit');
  Array.from(inputs).forEach(function (input) {
    input.addEventListener('input', function () {
      if (first_name.value == "" || last_name.value == "" || email.value == "") {
        console.log('required fields');
        submit.disabled = true;
      } else {
        submit.disabled = false;
      }
    });
  });
});

function toggleModal(id) {
  var modal = document.getElementById(id);
  modal.classList.toggle('is-open');
}